<template>
  <div>
    <div :id="id" :data="data" :style="{width: '100%', height: '100%'}" ref="echarts"></div>
  </div>
</template>
<script>
// import echarts from "echarts";

export default {
  name: "chart",
  props: {
    id: {
      type: String
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      chartLineGraph: ""
    };
  },
  created() {},
  mounted() {
    this.drawCharts(this.id, this.data);
  },
  watch: {
    data: {
      handler(newValue, oldValue) {
        if (this.chartLineGraph) {
          this.chartLineGraph.clear();
        }
        this.drawCharts(this.id, newValue);
      },
      deep: true
    }
  },
  methods: {
    drawCharts(id, data) {
      let _this = this;
      let myChar = document.getElementById(id);
      this.chartLineGraph = this.$echarts.init(myChar);
      this.chartLineGraph.setOption(data);
      window.addEventListener("resize", function() {
        _this.chartLineGraph.resize();
      });
    }
  },
  computed: {
    echarts() {
      return "echarts" + Math.random() * 100000;
    }
  },
  beforeDestroy() {
    if (this.chartLineGraph) {
      this.chartLineGraph.clear();
    }
  }
};
</script>
 
<style></style>